var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{attrs:{"disabled":_vm.disabled,"placeholder":_setup.languageFallback,"type":_vm.type},domProps:{"value":_setup.safeValue[_vm.language] ?? ''},on:{"input":function($event){return _setup.setValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }